var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wxinner-wrap"},[_c('background'),_c('div',{staticClass:"title"},[_vm._v("欢迎使用"+_vm._s(_vm.systemInfo.company))]),_c('div',{staticClass:"des"},[_vm._v("链接已失效！！")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }